import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DisciplinaryActionTypesServices from "./disciplinary_action_types.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDisciplinaryActionTypes = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: true,
    });
    const resp = await DisciplinaryActionTypesServices.getDisciplinaryActionTypes(filters);
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION_TYPES,
      payload: {
        disciplinaryActionTypes: resp.data.data,
        disciplinaryActionTypesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_ACTION_TYPES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_ACTION_TYPES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: false,
    });
  }
};

export const saveDisciplinaryActionTypes = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: true,
    });
    const resp = await DisciplinaryActionTypesServices.saveDisciplinaryActionTypes(data);
    const { disciplinaryActionTypes, disciplinaryActionTypesLength } = getState().disciplinaryActionType;
    const aDisciplinaryActionTypes = [...disciplinaryActionTypes, resp.data];
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION_TYPES,
      payload: {
        disciplinaryActionTypes: aDisciplinaryActionTypes,
        disciplinaryActionTypesLength: disciplinaryActionTypesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: false,
    });
  }
};

export const editDisciplinaryActionTypes = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: true,
    });
    const resp = await DisciplinaryActionTypesServices.editDisciplinaryActionTypes(id, data);
    const { disciplinaryActionTypes, disciplinaryActionTypesLength } = getState().disciplinaryActionType;
    disciplinaryActionTypes[index] = resp.data;
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION_TYPES,
      payload: {
        disciplinaryActionTypes: disciplinaryActionTypes,
        disciplinaryActionTypesLength: disciplinaryActionTypesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: false,
    });
  }
};

export const deleteDisciplinaryActionTypes = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: true,
    });
    await DisciplinaryActionTypesServices.deleteDisciplinaryActionTypes(id);
    const { disciplinaryActionTypes, disciplinaryActionTypesLength } = getState().disciplinaryActionType;
    disciplinaryActionTypes.splice(index, 1);
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION_TYPES,
      payload: {
        disciplinaryActionTypes: disciplinaryActionTypes,
        disciplinaryActionTypesLength: disciplinaryActionTypesLength - 1,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_ACTION_TYPES_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_ACTION_TYPES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION_TYPES,
      payload: false,
    });
  }
};
